const PERMISSION_KEY= "core:user_authority";
const PAGE_URL = {
    USER_AUTHORITY_PAGE: "/admin/core/user-authority"
}

export {PERMISSION_KEY, PAGE_URL}

